
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { IFrequencyObject } from "@/utils/frequency-object";

export default Vue.extend({
	data(){
		return {
			selectedItems: [] as number[]
		};
	},
	props: {
		value: {
			type: Object as () => IFrequencyObject,
			required: true
		},
		xs: {
			type: [String,Number],
			default: "12"
		},
		md: {
			type: [String, Number],
			default: "6"
		}
	},
	computed: {
		items():ISelectItem<number>[]{
			let result:ISelectItem<number>[] = [1,2,3,4,5,6].map(i=>{
				return {
					text: this.$ct(`common.weekday.${i-1}`),
					value: i
				};
			});
			result.push({
				text: this.$ct("common.weekday.6"),
				value: 0
			});
			return result;
		},
		allValues():number[]{
			return [0,1,2,3,4,5,6];
		},
	},
	watch: {
		selectedItems: {
			deep: true,
			handler(){
				this.onInput();
			}
		}
	},
	methods: {
		addDay(day:number) {
			this.value.FrequencyMoment = this.value.FrequencyMoment.split("").filter(d => d != `${day}`).concat(`${day}`).sort().join("");
		},
		removeDay(day:number) {
			this.value.FrequencyMoment = this.value.FrequencyMoment.split("").filter(d => d != `${day}`).sort().join("");
		},
		setHasDay(day:number, value:boolean) {
			if (value) {
				this.addDay(day);
			} else {
				this.removeDay(day);
			}
		},
		hasDay(day:number):boolean {
			return this.value.FrequencyMoment.indexOf(`${day}`) != -1;
		},
		onInput(){
			for (let val of this.allValues) {
				this.setHasDay(val, this.selectedItems.indexOf(val) != -1);
			}
		}
	},
	mounted(){
		this.selectedItems = this.allValues.filter(d=>this.hasDay(d));
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
